import React from "react"
import {Link, withRouter} from "react-router-dom"
import {
    HeaderContainer,
    Header,
    SideNav,
    SideNavItems,
    SideNavMenu,
    SideNavMenuItem,
    SkipToContent,
    HeaderName,
    HeaderGlobalBar,
    HeaderGlobalAction,
    SideNavLink,
    OverflowMenu,
    OverflowMenuItem
} from "carbon-components-react"
import {Logout20, CloudUpload32, DataCheck32, Dashboard32, FlowData32, UserAvatar32} from "@carbon/icons-react"
import data from "../../data"
import "./index.scss"

let bgStyle = {
    backgroundColor: process.env.REACT_APP_BG_HEADER_CLIENT + "!important",
};
export default withRouter(function index(props) {
    let dashs = process.env.REACT_APP_HAS_DASHBOARD === 'true' ? JSON.parse(localStorage.getItem('dashboards')) : false;
    let ij = (props.location.pathname.indexOf("/ij/painel") > -1 || props.location.pathname.indexOf("/ij/demo_financial") > -1 || props.location.pathname.indexOf("/ij/report") > -1 || props.location.pathname.indexOf("/ij/explorer") > -1)? true:false;
    let dj =(props.location.pathname.indexOf("/captura/manual") > -1 || props.location.pathname.indexOf("/repo/format") > -1 || props.location.pathname.indexOf("/ij/report_create_schneider") > -1 || props.location.pathname.indexOf("/ij/rh") > -1 || props.location.pathname.indexOf("/ij/rh_edit") > -1 || props.location.pathname.indexOf("/ij/plan") > -1 || props.location.pathname.indexOf("/ij/plan_edit") > -1)? true:false;
    let ej = (props.location.pathname.indexOf("/jobs/dashboard/") > -1 || props.location.pathname.indexOf("/jobs/executados") > -1 )? true:false;

    return (
        <HeaderContainer
            render={({isSideNavExpanded}) => (
                <>
                    <Header
                        className={`header ${process.env.REACT_APP_BG_HEADER_CLIENT ? "header-client" : process.env.REACT_APP_SYSTEM === "nxtoperations" ? 'header-operations' : 'header-demand'}`}
                        style={bgStyle}
                        aria-label="DomRock">
                        <SkipToContent/>
                        <HeaderName element={Link}
                                    to={localStorage.getItem("urlStandard")}
                                    prefix="">
                            {process.env.REACT_APP_NAME_HEADER_CLIENT ? (
                                <span style={{
                                    color: "#f3f3f3",
                                    fontSize: "18px"
                                }}>{process.env.REACT_APP_NAME_HEADER_CLIENT}</span>
                            ) : (
                                <img src={require("./assets/DR_logo.png")} alt="DomRock"/>
                            )
                            }
                            <span className="header-brand">{props.name}</span>
                        </HeaderName>
                        <HeaderGlobalBar>
                            <OverflowMenu renderIcon={UserAvatar32} flipped={true} light={true} size={'lg'}>
                                {(["SYSTEM ADMIN", "USER PERMISS"].includes(localStorage.getItem("typePermission"))) && (
                                    <OverflowMenuItem onClick={() => window.open("/user/permission", "_self")}
                                                      itemText="Configurações de usuários"/>
                                )}
                                {(["USER ADMIN"].includes(localStorage.getItem("typePermission"))) && (

                                    <OverflowMenuItem onClick={() => window.open("/user/config/", "_self")}
                                                      itemText="Gerenciamento de usuários"/>
                                )}
                                <OverflowMenuItem hasDivider onClick={() => window.open("/", "_self")}
                                                  itemText="Logout"/>
                            </OverflowMenu>
                        </HeaderGlobalBar>
                        { !(["USER ADMIN"].includes(localStorage.getItem("typePermission"))) && (
                        <SideNav aria-label="Side navigation" isRail >
                            <SideNavItems
                                onMouseEnter={() => alert("SAIU")}
                                expanded={isSideNavExpanded}
                                isPersistent={false}
                            >
                                <>
                                    {(process.env.REACT_APP_HAS_FINANCIAL_STATEMENT !== 'true' && process.env.REACT_APP_HAS_REPORT !== 'true' && process.env.REACT_APP_HAS_EXPLORER !== 'true' && process.env.REACT_APP_HAS_DASHBOARD !== 'true') ? ('') : (

                                        <>
                                            <SideNavMenu
                                                className={ij?'snMActive':''}
                                                aria-expanded={false}
                                                isActive={ij}
                                                renderIcon={Dashboard32} title={data.sideBar.intelligentJourney.title}>

                                                {
                                                    (dashs && ['SYSTEM ADMIN', 'USER GOLD'].includes(localStorage.getItem("typePermission"))) ? (dashs.map(d => (
                                                        d.panelType === 1
                                                        && (

                                                            <SideNavMenuItem element={Link}
                                                                             to={"/ij/painel/" + d.dashboardId}

                                                                             aria-current={
                                                                                 props.location.pathname === "/ij/painel/" + d.dashboardId
                                                                                     ? "page"
                                                                                     : ""
                                                                             }
                                                                             href="javascript:void(0)">{d.panelLabel}</SideNavMenuItem>
                                                        )
                                                    ))) : ("")
                                                }

                                                {(['USER GOLD'].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_HAS_FINANCIAL_STATEMENT === 'true') && (
                                                    <SideNavMenuItem element={Link}
                                                                     to={"/ij/demo_financial"}
                                                                     isActive={
                                                                         props.location.pathname === "/ij/demo_financial"
                                                                     }
                                                                     href="javascript:void(0)">{data.sideBar.intelligentJourney.links[4]}</SideNavMenuItem>
                                                )}

                                                {(['SYSTEM ADMIN', "USER SILVER", "USER GOLD"].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_HAS_REPORT === 'true') && (
                                                    <>
                                                        <SideNavMenuItem element={Link}
                                                                         to={"/ij/report"}
                                                                         isActive={
                                                                             props.location.pathname === "/ij/report"
                                                                         }
                                                                         href="javascript:void(0)">{data.sideBar.intelligentJourney.links[2]}</SideNavMenuItem>
                                                    </>
                                                )}
                                                {(['USER EXPLORER', "SYSTEM ADMIN", "USER SILVER", "USER GOLD"].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_HAS_EXPLORER === 'true') && (
                                                    <>
                                                        <SideNavMenuItem element={Link}
                                                                         to={"/ij/explorer"}
                                                                         isActive={
                                                                             props.location.pathname === "/ij/explorer"
                                                                         }
                                                                         href="javascript:void(0)">Explorer</SideNavMenuItem>
                                                    </>)}
                                            </SideNavMenu>
                                        </>)}
                                    {((process.env.REACT_APP_HAS_UPLOAD !== 'true' && process.env.REACT_APP_HAS_REPOSITORY_MASTER !== 'true' && process.env.REACT_APP_HAS_PLANNINGREV !== 'true') && (process.env.REACT_APP_X_TENANT_ID == 'esteecomissionamento-prv' || process.env.REACT_APP_X_TENANT_ID == 'esteecomissionamento-dev')) ? ('') : (
                                        <>
                                            <SideNavMenu className={dj?'snMActive':''} isActive={dj} renderIcon={FlowData32} title="Data Journey">
                                                {(['SYSTEM ADMIN', "USER BRONZE", "USER SILVER", "USER GOLD"].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_HAS_UPLOAD === 'true') && (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/captura/manual"
                                                                     isActive={
                                                                         props.location.pathname === "/captura/manual"
                                                                     }
                                                                     href="javascript:void(0)">{data.sideBar.dataset.title}</SideNavMenuItem>
                                                )}

                                                {(['SYSTEM ADMIN', "USER GOLD"].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_HAS_REPOSITORY_MASTER === 'true') && (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/repo/format"
                                                                     isActive={
                                                                         props.location.pathname === "/repo/format"
                                                                     }
                                                                     href="javascript:void(0)">Repository
                                                        Master</SideNavMenuItem>
                                                )}

                                                {(['SYSTEM ADMIN'].includes(localStorage.getItem("typePermission")) && process.env.REACT_APP_X_TENANT_ID == 'schneider-prv') && (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/ij/report_create_schneider?type=edit"
                                                                     isActive={
                                                                         props.location.pathname === "/ij/report_create_schneider" || props.location.pathname.includes("/ij/report_preview_edit_schneider")
                                                                     }
                                                                     href="javascript:void(0)">{data.sideBar.intelligentJourney.links[1]}</SideNavMenuItem>
                                                )}

                                                {((['SYSTEM ADMIN', "USER BRONZE", "USER SILVER", "USER GOLD"].includes(localStorage.getItem("typePermission"))) && (process.env.REACT_APP_X_TENANT_ID == 'esteecomissionamento-prv' || process.env.REACT_APP_X_TENANT_ID == 'esteecomissionamento-dev')) ? (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/ij/rh"
                                                                     isActive={
                                                                         props.location.pathname === "/ij/rh" || props.location.pathname.includes("/ij/rh_edit")
                                                                     }
                                                                     href="javascript:void(0)">Auxiliar
                                                        Padrão</SideNavMenuItem>
                                                ) : ('')}


                                                {process.env.REACT_APP_HAS_PLANNINGREV === 'true' && (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/ij/plan"
                                                                     isActive={
                                                                         props.location.pathname === "/ij/plan" || props.location.pathname === "/ij/plan_edit"
                                                                     }
                                                                     href="javascript:void(0)">{data.sideBar.intelligentJourney.links[1]}</SideNavMenuItem>
                                                )}
                                            </SideNavMenu>
                                        </>)}

                                    {process.env.REACT_APP_HAS_JOBS_EXECUTADOS === 'true' && (
                                        <SideNavMenu  isActive={ej} className={ej?'snMActive':''} renderIcon={DataCheck32} title="Executed Jobs">
                                            <>
                                                {
                                                    ((["USER GOLD",'SYSTEM ADMIN'].includes(localStorage.getItem("typePermission"))) && dashs) ? (dashs.map(d => (
                                                        d.panelType === 2
                                                        && (

                                                            <SideNavMenuItem element={Link}
                                                                             to={"/jobs/dashboard/" + d.dashboardId}

                                                                             aria-current={
                                                                                 props.location.pathname === "/jobs/dashboard/" + d.dashboardId
                                                                                     ? "page"
                                                                                     : ""
                                                                             }
                                                                             href="javascript:void(0)">{d.panelLabel}</SideNavMenuItem>
                                                        )
                                                    ))) : ("")
                                                }
                                                {(["USER GOLD",'SYSTEM ADMIN'].includes(localStorage.getItem("typePermission"))) && (
                                                    <SideNavMenuItem element={Link}
                                                                     to="/jobs/executados"
                                                                     isActive={
                                                                         props.location.pathname === "/jobs/executados"
                                                                     } renderIcon={DataCheck32}
                                                                     href="javascript:void(0)">
                                                        {data.sideBar.jobs.title}
                                                    </SideNavMenuItem>
                                                )}

                                            </>
                                        </SideNavMenu>
                                    )}
                                </>
                            </SideNavItems>
                        </SideNav>

                        )}
                    </Header>
                    {props.children}
                </>
            )}
        />
    )
})
